/**
 * Configurações globais da aplicação
 * Centraliza todas as configurações e constantes
 */

const fixedCtx = (
  (import.meta.env.VITE_PUBLIC_APP_CONTEXT as string) ||
  (import.meta.env.NEXT_PUBLIC_APP_CONTEXT as string) ||
  null
)

export const appConfig = {
  name: import.meta.env.VITE_APP_NAME || 'MyERP',
  description: 'Sistema de gerenciamento',
  locale: 'pt-BR',
  /** Fixed context from env (e.g. 'billing'). Null means multi-context mode.
   *  Accepts both Vite-style `VITE_PUBLIC_APP_CONTEXT` and legacy `NEXT_PUBLIC_APP_CONTEXT`
   *  to be resilient when developers keep old env files. */
  fixedContext: fixedCtx,
} as const

// Export a runtime app version. Prefer explicit Vite env `VITE_APP_VERSION`,
// fallback to package.json version bundled at build time.
import pkg from '../../package.json'
export const appVersion = (import.meta.env.VITE_APP_VERSION as string) || pkg.version || '0.0.0'

export const supabaseConfig = {
  url: import.meta.env.VITE_SUPABASE_URL!,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY!,
} as const

export const routes = {
  home: '/',
  login: '/login',
  signup: '/signup',
  dashboard: '/dashboard',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
} as const

/** Maps a context key to its own dashboard route */
export function getContextDashboardRoute(contextKey: string | null | undefined): string {
  switch (contextKey) {
    case 'billing': return '/billing'
    case 'assets':  return '/assets'
    case 'pricing': return '/pricing'
    case 'poultry':  return '/poultry'
    case 'accounting': return '/accounting'
    default:        return '/dashboard'
  }
}
